import { createAppSelector, selectClassSessionUserSummaries, selectCurrentCourseId } from "./base";

import type { ClassSessionUserSummaryType } from "components/server-types";

export const selectStudentClassSessionUserSummaries = createAppSelector(
  [selectClassSessionUserSummaries, selectCurrentCourseId],
  (summaries, courseId): ClassSessionUserSummaryType[] =>
    summaries.filter((s) => s.section_id === courseId && s.role === "student"),
);
